import { ICardElementWithChildren } from "backend/model/model";
import { getCachedModelByYear } from "qpr-base/context/modelsByYear";

// Get year from model ID (reverse lookup)
export const getYearFromModelId = (modelId: string): string | null => {
  if (modelId === "827938453") return "2025"; // legacy 2025 model id
  const entry = Object.entries(getCachedModelByYear()).find(([, id]) => id === modelId);
  return entry ? entry[0] : null;
};

// Extract model ID from element ID (format: SC.{modelId}.{elementId})
export const getModelIdFromElementId = (elementId: string): string | null => {
  const parts = elementId.split(".");
  if (parts.length >= 3 && parts[0] === "SC") {
    return parts[1];
  }
  return null;
};

// Get year from element ID
export const getYearFromElementId = (elementId: string): string | null => {
  const modelId = getModelIdFromElementId(elementId);
  if (!modelId) return null;
  return getYearFromModelId(modelId);
};

export const matchesAnyStringFields = (
  keys: Array<keyof ICardElementWithChildren>,
  v: ICardElementWithChildren,
  searchKey: string
): boolean => {
  const needle = searchKey.toLocaleLowerCase();
  return keys.some((k) => {
    const value = v[k];
    if (typeof value !== "string") return false;
    return value.toLocaleLowerCase().includes(needle);
  });
};

